import * as React from 'react'
import cx from 'classnames'
import styles from './FormActions.sass'

interface FormActionsProps {
  children?: React.ReactNode
}

export default function FormActions({ children }: FormActionsProps) {
  return (
    <div className={cx(styles.root)}>
      <div className={styles.actions}>{children}</div>
    </div>
  )
}
